import { useContext, useEffect, useState } from "react";
import { DashboardContext } from "../../../DashboardContext/DashboardContextProvider";
import RadioGroupField from "../Inputs/RadioGroupField";
import "../Inputs/styles/list-checkboxes.css";
import "../Inputs/styles/new-text.css";
import { FormContext } from "../context/FormProvider";
import { scrollToFirstRequiredField } from "../main-helper";
import "../styles/form-container.css";
import useSetSlide from "./Hooks/setSlide";
import useInvalidInputs from "./Hooks/useInvalidInputs";
import "./styles/services.css";

// Slide 3: Dust Services
const SafetyServices = ({ setSlideStatus, formStateLoaded }) => {
  const [disabledInputs, setDisabledInputs] = useState([]);
  const {
    slide2,
    setSlide2,
    setIsLoading,
    requestStatus,
    populateInvalidInputs,
    setPageNumber,
  } = useContext(FormContext);

  const { client, clientId, projectId } = useContext(DashboardContext);

  // Update Slide State
  const slide2Mutation = useSetSlide(
    clientId,
    projectId,
    2,
    setIsLoading,
    setSlideStatus,
  );

  // On Mount, the page should scroll to the top
  useEffect(() => {
    if (client && client.shortName === "Greystone") {
      let newState = {
        ...slide2,
        safetyInterest: "No",
        level1Safety: "No",
        level2Safety: "No",
      };
      setSlide2(newState);
      slide2Mutation.mutate(newState);

      setPageNumber(3);
    }
    scrollToFirstRequiredField(slide2);
  }, []);

  // Get Invalid Inputs
  const invalidInputsData = useInvalidInputs(
    clientId,
    projectId,
    requestStatus,
  );

  // Populate Invalid Inputs
  useEffect(() => {
    populateInvalidInputs(
      invalidInputsData,
      disabledInputs,
      setDisabledInputs,
      "2",
    );
  }, [invalidInputsData.data, invalidInputsData.isFetched]);

  return (
    <>
      {formStateLoaded ? (
        <>
          <RadioGroupField
            label="Argus is now offering safety consulting, would you like to learn more?"
            idProp="safetyInterest"
            state={slide2}
            setState={setSlide2}
            disabledInput={false}
            setIsLoading={setIsLoading}
            debouncedSave={slide2Mutation}
          />
          {slide2.safetyInterest === "Yes" && (
            <>
              <RadioGroupField
                label="Level 1 Safety Inspection"
                idProp="level1Safety"
                state={slide2}
                setState={setSlide2}
                val={slide2.level1Safety}
                disabledInput={false}
                setIsLoading={setIsLoading}
                debouncedSave={slide2Mutation}
              />
              <p className="important-text">
                {
                  "Level 1 Site Safety Inspection: A basic safety inspection identifying existing and potential hazards and analyzing the overall safety of the site"
                }
              </p>
              <RadioGroupField
                label="Level 2 Safety Inspection"
                idProp="level2Safety"
                state={slide2}
                setState={setSlide2}
                val={slide2.level2Safety}
                disabledInput={false}
                setIsLoading={setIsLoading}
                debouncedSave={slide2Mutation}
              />
              <p className="important-text">
                {
                  "Level 2 Site Safety Inspection: A more intensive and investigative site assessment that examines the entire site and identifies areas needing remedial action to avoid employee injuries and potential OSHA monetary penalties"
                }
              </p>
            </>
          )}
        </>
      ) : (
        <p className="slide-loading">Loading...</p>
      )}
    </>
  );
};

export default SafetyServices;
